import * as React from 'react';
import MoreOptionsPopup from './MoreOptionsPopup';
import StaticElementButton from './StaticElementButton';

interface MoreOptionsOption {
  text: string;
  value: string;
}

interface MoreOptionsProps {
  options: MoreOptionsOption[];
  onSelect?: Function;
  id: string;
}

interface MoreOptionsState {
  popupOpened: boolean;
}

export default function MoreOptions(props: MoreOptionsProps) {
  const [state, setState] = React.useState<MoreOptionsState>({
    popupOpened: false
  });

  return state.popupOpened ? (
    <MoreOptionsPopup
      onBlur={() => {
        setState({ ...state, popupOpened: false });
      }}
      options={props.options}
      onSelect={(selectedOption: string) => {
        setState({ ...state, popupOpened: false });
        if (props.onSelect !== undefined) {
          props.onSelect(selectedOption);
        }
      }}
    />
  ) : (
    <StaticElementButton
      onClick={() => {
        setState({ ...state, popupOpened: true });
      }}
      name="ellipse"
      id={`ellipse-${props.id}`}
      label="More"
      type="div"
    >
      <span className="ellipse">&nbsp;</span>
    </StaticElementButton>
  );
}
